var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.493,
    height: 24.37,
    viewBox: "0 0 32.493 24.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M69.415,66.708A2.708,2.708,0,1,1,66.708,64,2.708,2.708,0,0,1,69.415,66.708Zm0,0",
    transform: "translate(-59.938 -59.938)",
    fill: "#3b56a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M28.431,0H4.062A4.067,4.067,0,0,0,0,4.062V20.308c0,.076.019.148.023.223a1,1,0,0,0,.049.481,4.06,4.06,0,0,0,3.99,3.358h24.37a4.067,4.067,0,0,0,4.062-4.062V4.062A4.067,4.067,0,0,0,28.431,0ZM4.062,2.708h24.37a1.356,1.356,0,0,1,1.354,1.354V14.81L22.664,7.689a2.376,2.376,0,0,0-3.358,0l-6.444,6.444-1.706-1.706a2.376,2.376,0,0,0-3.358,0l-5.09,5.09V4.062A1.356,1.356,0,0,1,4.062,2.708Zm0,0",
    fill: "#3b56a7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.62c67bf769a6d824f178bf459278a46f.svg";
export { ForwardRef as ReactComponent };